
export const handleFieldValidation = (valueField, noteField) => {
  if (!valueField && valueField !== 0) {
    return 'Enter in a Value';
  }

  if (valueField === 0 && !noteField) {
    return 'Needs Reason.';
  }
  return null;
};
